function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import api from "../api";
import Resource from "./common";
import security from "../security";
import _logger from "../logger";

var UserResource = /*#__PURE__*/function (_Resource) {
  _inherits(UserResource, _Resource);

  var _super = _createSuper(UserResource);

  function UserResource() {
    var entrypoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/users';
    var alias = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'User';

    _classCallCheck(this, UserResource);

    return _super.call(this, entrypoint, alias);
  }
  /**
   * Anonymize a user item of a users collection
   *
   * @param {string|string[]|number|number[]} id
   *
   * @return {Promise}
   */


  _createClass(UserResource, [{
    key: "anonymize",
    value: function anonymize(id) {
      var isMultiple = Array.isArray(id);
      return api.get(isMultiple ? this.buildUri('anonymize') : this.buildUri(id, 'anonymize'), isMultiple ? {
        id: id,
        perPage: id.length
      } : {});
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "canUpdate",
    value: function canUpdate() {
      var canRead = security.hasPermission('User', 'read', false);
      var canUpdate = security.hasPermission('User', 'update', false);
      return canRead === true && canUpdate === true || canRead !== false && canUpdate !== false && security.isGranted('ROLE_ADMIN');
    }
  }, {
    key: "canAnonymize",
    value: function canAnonymize() {
      return security.hasPermission(this.alias, 'anonymize');
    }
  }, {
    key: "canAnonymizeMultiple",
    value: function canAnonymizeMultiple() {
      return security.hasPermission(this.alias, 'anonymize:multiple');
    }
    /**
     * Récupère pour un utilisateur les documents à valider.
     *
     * @param {array|null} communitiesIds
     */

  }, {
    key: "getDocumentToValide",
    value: function getDocumentToValide(communitiesIds) {
      return api.get("".concat(this.entrypoint, "/me/documents/to_validate").concat(communitiesIds ? "?ids=".concat(JSON.stringify(communitiesIds)) : ''));
    }
  }, {
    key: "saveDocumentValidate",
    value: function saveDocumentValidate(documents) {
      return api.post("".concat(this.entrypoint, "/me/documents/validate"), {
        documents: documents
      });
    }
  }]);

  return UserResource;
}(Resource);

export { UserResource as default };